import * as z from "zod";
import type { TFunction } from "i18next";

export const assignComplexAdminSchema = (t: TFunction) =>
  z.object({
    userId: z
      .string({ required_error: t("admin.access.form.validation.userRequired") })
      .min(1, t("admin.access.form.validation.userRequired")),
    complexId: z
      .string({
        required_error: t("admin.access.form.validation.complexRequired"),
      })
      .min(1, t("admin.access.form.validation.complexRequired")),
  });

export type AssignComplexAdminFormData = z.infer<
  ReturnType<typeof assignComplexAdminSchema>
>;
